import { useMemo } from 'react';
import useSetStateArray from './array/useSetState';
export function useSetState(initialValue) {
    const [state, setState, resetState] = useSetStateArray(initialValue);
    return useMemo(() => ({
        setState,
        resetState,
        state,
    }), [setState, resetState, state]);
}
export default useSetState;
//# sourceMappingURL=useSetState.js.map